export enum LogColor {
  None = '',
  Red = 'background-color: #c44536; color: #ffffff; padding: .2rem .3rem .2rem .3rem;',
  Green = 'background-color: #197278; color: #ffffff; padding: .2rem .3rem .2rem .3rem;',
  Black = 'background-color: #000000; color: #ffffff; padding: .2rem .3rem .2rem .3rem;',
}
